export const SEO_DEFAULTS = {
  siteName: 'Celebrity Smile Studio',
  titleSuffix: '| Celebrity Smile Studio — Flourtown, PA',
  defaultTitle: 'Family & Pediatric Dentist | Flourtown, Chestnut Hill &amp; Philadelphia PA',
  defaultDescription: 'Celebrity Smiles provides a full range of quality dental treatments, from tooth extractions to dental implants, at fair prices. For more details, visit our website or call us at 215-233-5811.',
  defaultKeywords: 'dentist flourtown, family dentist flourtown pa, special care dentistry',
  siteUrl: 'https://www.flourtowndentist.com/',
};

export function buildTitle(title) {
  if (!title) return SEO_DEFAULTS.defaultTitle;
  return `${title} ${SEO_DEFAULTS.titleSuffix}`;
}

export const SCHEMA_DENTAL_PRACTICE = {
  '@context': 'https://schema.org',
  '@type': 'Dentist',
  name: 'Celebrity Smile Studio',
  url: 'https://www.flourtowndentist.com/',
  telephone: '+2152335811',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1811 Bethlehem Pike St Ste B235',
    addressLocality: 'Flourtown',
    addressRegion: 'PA',
    postalCode: '19031',
    addressCountry: 'US',
  },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Monday', opens: '09:00', closes: '17:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Tuesday', opens: '10:00', closes: '18:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Wednesday', opens: '09:00', closes: '17:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Thursday', opens: '10:00', closes: '18:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Friday', opens: '09:00', closes: '13:00' },
  ],
  aggregateRating: { '@type': 'AggregateRating', ratingValue: '5', reviewCount: '71', bestRating: '5' },
};
